import React from 'react';
import { Visibility } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { AppBar, Tab, Tabs, Grid } from '@mui/material';
import { Button, Dialog, IconButton } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';
import EvaluationLogXMLViewerWrapper from './EvaluationLogXMLViewerWrapper';

const EvaluationLogXmlContentComponent = ({ onPopUpChange, openPopUp, data, loading, tabValue, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton id='xml-view-button' size='small' variant='text' onClick={onPopUpChange(openPopUp)}>
        <Visibility />
      </IconButton>
      {openPopUp && (
        <Dialog
          title={t('EvaluationLogs.XmlContents')}
          onClose={onPopUpChange(openPopUp)}
          aria-labelledby='customized-dialog-title'
          open={openPopUp}
          fullWidth={true}
          maxWidth={'lg'}
          content={
            !loading && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <AppBar position='static' color='default'>
                    <Tabs value={tabValue} onChange={onTabChange} indicatorColor='primary' textColor='primary' variant='scrollable'>
                      <Tab label={t('EvaluationLogs.InputData')} />
                      <Tab label={t('EvaluationLogs.ProcessData')} />
                      <Tab label={t('EvaluationLogs.ExecutionData')} />
                    </Tabs>
                  </AppBar>
                </Grid>
                <Grid item xs={12}>
                  <EvaluationLogXMLViewerWrapper tabValue={tabValue} data={data.evaluationLogXmlData} />
                </Grid>
              </Grid>
            )
          }
          actions={
            <Button autoFocus onClick={onPopUpChange(openPopUp)} color='primary' variant='outlined'>
              {t('EvaluationLogs.ClosePopUp')}
            </Button>
          }
        />
      )}
    </>
  );
};
EvaluationLogXmlContentComponent.propTypes = {
  onPopUpChange: PropTypes.func.isRequired,
  openPopUp: PropTypes.bool.isRequired,
  data: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  onTabChange: PropTypes.func.isRequired,
  tabValue: PropTypes.number.isRequired
};

export default EvaluationLogXmlContentComponent;
